module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm2"
    }
  }, [_c('p', {
    staticClass: "centerImage00"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/transcript.jpg",
      "width": "88%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-bottom": "3%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("RETRIEVED FROM AIR TRAFFIC CONTROL RECORDINGS, FAIRBANKS, ALASKA.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI = Sam Tennison, Fairbanks Air Traffic Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Captain Frank Benoit, AH16")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("First Officer Alexis Card, AH16")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Flight Attendant Pete Meriwether, AH16")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg",
      "width": "95%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("21:13:42.7")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Aero Horizon 16, things are looking bumpy ahead of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We see it. How deep?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("You should be through in two minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Thanks, Fairbanks.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("No problem.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Pete, can you sit them down back there?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FLIGHT ATTENDANT (INTERCOM):")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Us too?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(pause)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Everyone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "3%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("21:15:24.3")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Are you seeing this?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(unintelligible) … flash of lightning?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("But it’s just sitting there.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We’ve got an electrical—")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Losing everything!")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Battery kicking in.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Okay. Okay. Instruments are back.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("What WAS that?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("I’m taking us lower. We need to get under this.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "3%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("21:15:50.1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(alarm)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Bird strike. We have bird strike.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("At 28,000 feet? There’s no birds up—")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("On engine three. Flame condition.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Shut it down.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("I’m trying.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("The status of your aircraft, please.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We have fire in number three. Won’t shut down. Losing speed …")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(stall alarm)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(auto-pilot disengage alarm)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We are in manual. Descending.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Okay.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("I have the controls.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Smoke in the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(multiple alarms)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Horizon 16, we have an emergency inbound runway available.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We’re unable.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FLIGHT ATTENDANT (INTERCOM):")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We have smoke in the cabin.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Right ahead! Another one!")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("I’m sorry. Say again?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("We—What IS that?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(sound of metal tearing)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FIRST OFFICER:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("It’s in here with us! It’s in here with—")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(sound of rushing air)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("CAPTAIN:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("She’s (unintelligible) gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(sound of tearing metal, rushing air)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "3%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("21:16:14.2")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Horizon 16, radar contact is lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(unintelligible)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Horizon 16, are you still on?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(rushing air)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("FAI:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("Horizon 16?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("(radio contact lost)")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg",
      "width": "95%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("End of transcript. Cause of crash as yet undetermined.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("No black box found. No wreckage found.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticStyle: {
      "font-family": "sans-serif"
    }
  }, [_vm._v("No survivors found.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c5c66e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545916790_fm002.vue
// module id = 69
// module chunks = 0